import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  isDevMode,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { cloneDeep, each, find, findIndex, forEach, groupBy, has, identity, isArray, isEmpty, isEqual, map, orderBy } from 'lodash';

import { TicketsAssignService } from './tickets-assign.service';
import { WORK_SHIFT_PATHS } from '../../../work-shift';
import { combineLatest, forkJoin, Observable, Subject, Subscription } from 'rxjs';
import { Enums } from '../../../../../configs/Enums';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '../../../../../shared/modals/confirm-modal/confirm-modal.component';
import { DeactivationGuarded } from '../../../../../classes/canDeactivate';
import { TicketsAssignErrorModalComponent } from './components/tickets-assign-error-modal/tickets-assign-error-modal.component';
import { TicketViewService } from '../../../../tickets/ticket-view/ticket-view.service';
import { TicketsMatrixComponent } from './components/tickets-matrix/tickets-matrix.component';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../../auth/auth.service';
import { TicketsService } from './components/services/tickets.service';
import { TicketTypesEnum } from '../../constants/ticket-types.constant';
import { AuthGroupTypesEnum } from '../../../../auth/auth-group-types.enum';
import { SectorRole } from '../../../../sectors/sectors';
import { AutomaticDistributionSettingsModalComponent } from './components/automatic-distribution-settings-modal/automatic-distribution-settings-modal.component';
import { AutomaticDistributionProgressModalComponent } from './components/automatic-distribution-progress-modal/automatic-distribution-progress-modal.component';
import { WorkShiftService } from '../../../work-shift.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-assign-new',
  templateUrl: './tickets-assign.component.html',
  styleUrls: ['./tickets-assign.component.scss'],
  providers: [TicketsService],
  standalone: false,
})
export class TicketsAssignComponent implements OnInit, OnDestroy, DeactivationGuarded {
  private _destroyed$ = new Subject<void>();
  private automaticDistributionPollingTimerId = null;
  private automaticDistributionAnalysisPollingTimerId = null;
  private automaticDistributionResultSubscription: Subscription;
  private automaticDistributionOriginalTicketsSubscription: Subscription;
  private automaticDistributionAnalysisSubscription: Subscription;
  private automaticDistributionProgressModalRef: NgbModalRef = null;
  private ignoreAutomaticDistributionProgressClose = false;
  private readonly automaticDistributionPollingIntervalMs = 10000;
  private readonly automaticDistributionAnalysisPendingStatuses = ['queued', 'pending', 'processing', 'running', 'in_progress'];
  private readonly automaticDistributionAnalysisFailedStatuses = ['failed', 'error'];
  private initialQueryParams: any = null; // Параметры из sessionStorage для window.open
  public moment = require('moment');
  public dateShortFormat = Enums.dates.shortFormat;
  public dateFullFormat = Enums.dates.fullFormat;

  public parentParams = { sectorSelected: null };
  public childParams: any = {
    int_begin: '',
    int_end: '',
    districts_ids: '',
    address: '',
    tickets_types_ids: '',
    brigades_ids: '',
    hd_ticket_number: '',
    ticket_status: '',
    hd_ticket_status_group: '',
    gp_types: '',
    gp_subtypes: '',
    responsible_groups: '',
    responsible_users: '',
  };

  public childParamsDefault = {
    int_begin: this.moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
    int_end: this.moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
    districts_ids: '',
    address: '',
    tickets_types_ids: '1,2,3,4,5,6',
    brigades_ids: '',
    hd_ticket_number: '',
    ticket_status: '11,1,2,3,4,5,6,7,8,9,10',
    hd_ticket_status_group: '1,2,3,4,5,6,7,8',
    gp_types: '',
    gp_subtypes: '',
    responsible_groups: '',
    responsible_users: '',
  };

  public loading = true;

  public ticketsPeriodFilter = {
    data: {
      districts: null,
      ticketsTypes: null,
      brigades: null,
      ticketsHdStatuses: null,
      ticketsVkStatuses: null,
      typeGPs: null,
      subtypeGPs: null,
      responsibleGroups: null,
      responsibleUsers: null,
    },
    dateRange: {
      startDate: {
        options: null,
        dateObj: null,
        initDate: this.moment().startOf('day')._d,
        currentDate: this.moment().startOf('day')._d,
      },
      endDate: {
        options: null,
        dateObj: null,
        initDate: this.moment().endOf('day')._d,
        currentDate: this.moment().endOf('day')._d,
      },
    },
    districtsSelected: null,
    address: null,
    typeGPSelected: null,
    appliedTypeGPs: null,
    appliedSubtypeGPs: null,
    subtypeGPSelected: null,
    ticketTypesSelected: null,
    appliedSubtypeGPSelected: null,
    brigadesSelected: null,
    ticketNumber: null,
    ticketHdStatusesSelected: null,
    ticketsVkStatusesSelected: null,
    responsibleGroupsSelected: null,
    responsibleUsersSelected: null,
    applyFilter: () => {
      this.applyPeriodFilter();
    },
    resetFilter: () => {
      this.resetPeriodFilter();
    },
    exportFilter: () => {
      this.exportPeriodFilter();
    },
  };
  public ticketsPeriodFilterDefault = {
    data: {
      districts: null,
      ticketsTypes: null,
      brigades: null,
      ticketsHdStatuses: null,
      ticketsVkStatuses: null,
      typeGPs: null,
      subtypeGPs: null,
      responsibleGroups: null,
      responsibleUsers: null,
    },
    dateRange: {
      startDate: {
        options: null,
        dateObj: null,
        initDate: this.moment().startOf('day')._d,
        currentDate: this.moment().startOf('day')._d,
      },
      endDate: {
        options: null,
        dateObj: null,
        initDate: this.moment().endOf('day')._d,
        currentDate: this.moment().endOf('day')._d,
      },
    },
    districtsSelected: null,
    address: null,
    typeGPSelected: null,
    appliedTypeGPs: null,
    appliedSubtypeGPs: null,
    subtypeGPSelected: null,
    ticketTypesSelected: null,
    appliedSubtypeGPSelected: null,
    brigadesSelected: null,
    ticketNumber: null,
    ticketHdStatusesSelected: null,
    ticketsVkStatusesSelected: null,
    responsibleGroupsSelected: null,
    responsibleUsersSelected: null,
    applyFilter: () => {
      this.applyPeriodFilter();
    },
    resetFilter: () => {
      this.resetPeriodFilter();
    },
    exportFilter: () => {
      this.exportPeriodFilter();
    },
  };
  public ticketsCurrentFilter = {
    mode: this.getMode(),
    assignDaysList: [
      { id: 1, name: 'Сегодня', countDays: 0 },
      { id: 2, name: 'Завтра', countDays: 1 },
    ],
    assignDaySelected: null,
    currentFilterTypes: {
      assigned: {
        counts: 0,
        ticketStatuses: [2, 3, 6, 7, 8],
        id: 'assigned',
      },
      unassigned: { counts: 0, ticketStatuses: [1], id: 'unassigned' },
      opened: { counts: 0, ticketStatuses: [14], id: 'opened' },
      needActions: {
        counts: 0,
        ticketStatuses: [4, 5, 9],
        id: 'needActions',
      },
      all: { counts: 0, ticketStatuses: [], id: 'all' },
    },
    currentFilterTypeSelected: null,
    applyFilter: () => {
      this.applyPeriodFilter();
    },
    ticketsSettings: null,
    changeDayForAssigment: this.changeDayForAssigment.bind(this),
    changeTypeSelected: this.changeTypeSelected.bind(this),
    onChangeMode: this.onChangeMode.bind(this),
    resetTicketStatus: this.resetTicketStatus.bind(this),
    recalculateStatusAndTickets: () => {
      this.recalculateStatusAndTickets((ticket) => {
        const selectedTypeGPs = this.ticketsPeriodFilter.appliedTypeGPs.filter((appliedGP) => appliedGP.selected);
        const selectedSubtypeGPs = this.ticketsPeriodFilter.appliedSubtypeGPSelected;

        const correctTypeGP = selectedTypeGPs.findIndex((typeGP) => ticket.hd_ticket_type.id === typeGP.id) !== -1;
        const correctSubtypeGP = selectedSubtypeGPs.length ? selectedSubtypeGPs.findIndex((subtypeGP) => ticket.extra_flags.gp_subtype === subtypeGP.id) !== -1 : true;

        return correctTypeGP && correctSubtypeGP;
      });
    },
  };
  public ticketsCurrentFilterDefault = {
    mode: this.getMode(),
    assignDaysList: [
      { id: 1, name: 'Сегодня', countDays: 0 },
      { id: 2, name: 'Завтра', countDays: 1 },
    ],
    assignDaySelected: null,
    currentFilterTypes: {
      assigned: {
        counts: 0,
        ticketStatuses: [2, 3, 6, 7, 8],
        id: 'assigned',
      },
      unassigned: { counts: 0, ticketStatuses: [1], id: 'unassigned' },
      opened: { counts: 0, ticketStatuses: [14], id: 'opened' },
      needActions: {
        counts: 0,
        ticketStatuses: [4, 5, 9],
        id: 'needActions',
      },
      all: { counts: 0, ticketStatuses: [], id: 'all' },
    },
    currentFilterTypeSelected: null,
    applyFilter: () => {
      this.applyPeriodFilter();
    },
    ticketsSettings: null,
    changeDayForAssigment: this.changeDayForAssigment.bind(this),
    changeTypeSelected: this.changeTypeSelected.bind(this),
    onChangeMode: this.onChangeMode.bind(this),
    resetTicketStatus: this.resetTicketStatus.bind(this),
    recalculateStatusAndTickets: () => {
      this.recalculateStatusAndTickets((ticket) => {
        const selectedTypeGPs = this.ticketsPeriodFilter.appliedTypeGPs.filter((appliedGP) => appliedGP.selected);
        const selectedSubtypeGPs = this.ticketsPeriodFilter.appliedSubtypeGPSelected;

        const correctTypeGP = selectedTypeGPs.findIndex((typeGP) => ticket.hd_ticket_type.id === typeGP.id) !== -1;
        const correctSubtypeGP = selectedSubtypeGPs.length ? selectedSubtypeGPs.findIndex((subtypeGP) => ticket.extra_flags.gp_subtype === subtypeGP.id) !== -1 : true;

        return correctTypeGP && correctSubtypeGP;
      });
    },
  };
  public ticketsMultipleAssign = {
    brigades: null,
    brigadeSelected: null,
    ticketsChecked: null,
    isExistCheckedTicket: false,
    onChangeBrigadeForAssigment: this.onChangeBrigadeForAssigment.bind(this),
    onCheckedTicket: this.onChangeCheckedTicket.bind(this),
    onAddTicketsToBrigades: this.onAddTicketsToBrigades.bind(this),
    ticketsListRefresh: this.ticketsListRefresh.bind(this),
    onResetCheckedTickets: this.onResetCheckedTickets.bind(this),
  };
  public ticketsMultipleAssignDefault = {
    brigades: null,
    brigadeSelected: null,
    ticketsChecked: null,
    isExistCheckedTicket: false,
    onChangeBrigadeForAssigment: this.onChangeBrigadeForAssigment.bind(this),
    onCheckedTicket: this.onChangeCheckedTicket.bind(this),
    onAddTicketsToBrigades: this.onAddTicketsToBrigades.bind(this),
    ticketsListRefresh: this.ticketsListRefresh.bind(this),
    onResetCheckedTickets: this.onResetCheckedTickets.bind(this),
  };
  public tickets = {
    data: null,
    dataTable: null,
    dataMatrix: null,
    dataFlatList: null,
    ticketsLoading: false,
  };
  public brigadeAssignData = {
    brigades: [],
    isAssignedSuccess: false,
    isAssignedLoading: false,
    assignBrigades: () => {
      this.assignBrigades();
    },
    addBrigade: (obj) => {
      this.addAssignBrigade(obj);
    },
    removeBrigade: (obj) => {
      this.removeAssignBrigade(obj);
    },
  };
  public intervals = [
    {
      index: 0,
      interval: '00.00 - 12.00',
      startTime: { hours: 0, minutes: 0, seconds: 0 },
      endTime: { hours: 11, minutes: 59, seconds: 59 },
    },
    {
      index: 1,
      interval: '12.00 - 14.00',
      startTime: { hours: 12, minutes: 0, seconds: 0 },
      endTime: { hours: 13, minutes: 59, seconds: 59 },
    },
    {
      index: 2,
      interval: '14.00 - 16.00',
      startTime: { hours: 14, minutes: 0, seconds: 0 },
      endTime: { hours: 15, minutes: 59, seconds: 59 },
    },
    {
      index: 3,
      interval: '16.00 - 18.00',
      startTime: { hours: 16, minutes: 0, seconds: 0 },
      endTime: { hours: 17, minutes: 59, seconds: 59 },
    },
    {
      index: 4,
      interval: '18.00 - 20.00',
      startTime: { hours: 18, minutes: 0, seconds: 0 },
      endTime: { hours: 19, minutes: 59, seconds: 59 },
    },
    {
      index: 5,
      interval: '20.00 - 00.00',
      startTime: { hours: 20, minutes: 0, seconds: 0 },
      endTime: { hours: 23, minutes: 59, seconds: 59 },
    },
  ];
  public brigadeAssignDataDefault = {
    brigades: [],
    isAssignedSuccess: false,
    isAssignedLoading: false,
    assignBrigades: () => {
      this.assignBrigades();
    },
    addBrigade: (obj) => {
      this.addAssignBrigade(obj);
    },
    removeBrigade: (obj) => {
      this.removeAssignBrigade(obj);
    },
  };
  public automaticDistribution = {
    isChecking: false,
    isRunning: false,
    hasResult: false,
    showMap: false,
    showSchedule: false,
    resultLoading: false,
    resultError: null,
    result: null,
    resultDate: null,
    originalTickets: null,
    originalTicketsContext: null,
    originalTicketsLoading: false,
    originalTicketsError: null,
    analysisLoading: false,
    analysisError: null,
    transactionId: null,
    transactionDate: null,
    lastSettings: null,
    exportContext: {
      sectorName: '',
      sectorId: null,
    },
    isSavingResult: false,
    saveResultError: null,
    saveResultSuccess: false,
    start: () => {
      this.startAutomaticDistributionScenario();
    },
    toggleMap: () => {
      this.toggleAutomaticDistributionMap();
    },
    toggleSchedule: () => {
      this.toggleAutomaticDistributionSchedule();
    },
    saveResult: () => {
      this.saveAutomaticDistributionResult();
    },
  };

  @ViewChild('filterAssignWrapper')
  filterAssignWrapper: ElementRef;
  @ViewChild('filterAssignContainer')
  filterAssignContainer: ElementRef;

  @ViewChild(TicketsMatrixComponent)
  ticketsMatrixComponent: TicketsMatrixComponent;

  @HostListener('window:scroll.out-zone', []) // notice out-zone
  onWindowScroll() {
    if (this.isAutomaticDistributionResultVisible() || this.ticketsCurrentFilter.mode !== 'matrix') {
      this.resetFilterAssignFixedPosition();
      return;
    }
    if (!this.filterAssignWrapper || !this.filterAssignWrapper.nativeElement) {
      return;
    }
    const fixedBlockWidth = this.filterAssignWrapper.nativeElement.offsetWidth;
    const topCoords = this.filterAssignWrapper.nativeElement.getBoundingClientRect().top;

    if (topCoords <= 0) {
      if (this.filterAssignContainer && this.filterAssignContainer.nativeElement) {
        this.filterAssignContainer.nativeElement.style.width = fixedBlockWidth + 'px';
        this.filterAssignContainer.nativeElement.classList.add('filter-assign__container--fixed');
      }
    } else {
      if (this.filterAssignContainer && this.filterAssignContainer.nativeElement) {
        this.filterAssignContainer.nativeElement.style.width = 'auto';
        this.filterAssignContainer.nativeElement.classList.remove('filter-assign__container--fixed');
      }
    }
    //
  }

  private isAutomaticDistributionResultVisible(): boolean {
    return !!(this.automaticDistribution && (this.automaticDistribution.showMap || this.automaticDistribution.showSchedule));
  }

  private resetFilterAssignFixedPosition(): void {
    if (!this.filterAssignContainer || !this.filterAssignContainer.nativeElement) {
      return;
    }

    this.filterAssignContainer.nativeElement.style.width = 'auto';
    this.filterAssignContainer.nativeElement.classList.remove('filter-assign__container--fixed');
  }

  private getMode() {
    if (this.authService.isGRSUser()) {
      return 'table';
    }

    return this.ticketsPage ? 'matrix' : 'map';
  }

  isGRSUser(): boolean {
    return this.authService.isGRSUser();
  }

  get ticketsPage(): boolean {
    return (
      this.route.snapshot.data.navigateTo.includes(WORK_SHIFT_PATHS.work_shift_tickets) || this.route.snapshot.data.navigateTo.includes(WORK_SHIFT_PATHS.work_shift_tickets_new)
    );
  }

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private ticketsAssignService: TicketsAssignService,
    private ticketViewService: TicketViewService,
    private authService: AuthService,
    private ticketsService: TicketsService,
    private workShiftService: WorkShiftService,
    private modalService: NgbModal,
    private ngZone: NgZone
  ) {}

  public ngOnInit() {
    console.log('TicketsAssignNewComponent ngOnInit called');

    // Проверяем фиксированный ключ в sessionStorage (backup для window.open)
    const storageKey = 'tickets_assign_pending_params';
    const storedParams = sessionStorage.getItem(storageKey);

    if (storedParams) {
      try {
        const params = JSON.parse(storedParams);
        const timestamp = params._timestamp;
        const age = Date.now() - timestamp;

        // Используем параметры только если они "свежие" (< 5 секунд)
        if (age < 5000) {
          delete params._timestamp;
          this.initialQueryParams = params;
        }
        // Очищаем параметры после проверки
        sessionStorage.removeItem(storageKey);
      } catch (e) {
        console.error('Failed to parse stored params:', e);
        sessionStorage.removeItem(storageKey);
      }
    }

    this.subscribeParentRoute();
    this.subscribeSectorExportContext();
    this.subscribeChildRouter();
  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this.stopAutomaticDistributionPolling();

    if (this.automaticDistributionResultSubscription) {
      this.automaticDistributionResultSubscription.unsubscribe();
    }

    if (this.automaticDistributionOriginalTicketsSubscription) {
      this.automaticDistributionOriginalTicketsSubscription.unsubscribe();
    }

    this.stopAutomaticDistributionAnalysisPolling();

    if (this.automaticDistributionProgressModalRef) {
      this.ignoreAutomaticDistributionProgressClose = true;
      this.automaticDistributionProgressModalRef.dismiss();
      this.automaticDistributionProgressModalRef = null;
    }
  }

  public canDeactivate(): any {
    console.log('TicketsAssignNewComponent canDeactivate called');
    return new Promise((resolve) => {
      // Проверяем, что компонент полностью инициализирован
      if (!this.brigadeAssignData) {
        console.log('TicketsAssignNewComponent: brigadeAssignData not initialized');
        resolve(true);
        return;
      }

      if (this.brigadeAssignData.brigades && this.brigadeAssignData.brigades.length) {
        console.log('TicketsAssignNewComponent: showing confirm dialog');
        this.onAssignedConfirmDialog().result.then(
          () => {
            this.brigadeAssignData = cloneDeep(this.brigadeAssignDataDefault);
            resolve(true);
          },
          () => {
            resolve(false);
          }
        );
      } else {
        console.log('TicketsAssignNewComponent: no brigades to confirm');
        resolve(true);
      }
    });
  }

  private subscribeParentRoute(): void {
    this.route.data.pipe(takeUntil(this._destroyed$)).subscribe((data) => {
      if (isDevMode()) {
        console.log('~~~~ОБНОВЛЕНИЕ СЕКТОРА~~~~ =>', data.sectorId);
      }

      this.parentParams.sectorSelected = {
        sector_id: data.sectorId || null,
      };
    });
  }

  private subscribeSectorExportContext(): void {
    this.workShiftService
      .subscribeSectorData()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((sector) => {
        if (!sector || !sector.sector_id) {
          return;
        }

        this.automaticDistribution.exportContext = {
          sectorName: sector.sector_number_str || '',
          sectorId: sector.sector_id,
        };
      });
  }

  private subscribeChildRouter(): void {
    const self = this;

    // Комбинируем params и queryParams для поддержки обоих способов передачи параметров
    combineLatest([this.route.params, this.route.queryParams])
      .pipe(takeUntil(this._destroyed$))
      .subscribe(([params, queryParams]: [any, any]) => {
        if (isDevMode()) {
          console.log('~~~~ИЗМЕНЕНИЯ В ДОЧЕРНЕМ СОСТОЯНИИ~~~~');
        }

        // Выбираем источник параметров
        let isFromQueryParams = false;

        // 1. Приоритет - matrix параметры
        if (Object.keys(params).length > 0) {
          // Используем matrix параметры
        }
        // 2. Fallback - query параметры
        else if (Object.keys(queryParams).length > 0) {
          params = queryParams;
          isFromQueryParams = true;
        }
        // 3. Backup - sessionStorage (для window.open)
        else if (this.initialQueryParams && Object.keys(this.initialQueryParams).length > 0) {
          params = this.initialQueryParams;
          isFromQueryParams = true;
          // Очищаем после первого использования
          this.initialQueryParams = null;
        }

        let countParameters = 0;
        let countExistsParameters = 0;
        const missingParams = [];

        each(self.childParams, function (value, key) {
          countParameters++;

          if (has(params, [key])) {
            countExistsParameters++;
          } else {
            missingParams.push(key);
          }
        });

        forEach(self.childParams, (value, key) => {
          self.childParams[key] = value;
        });

        this.ticketsPeriodFilter = cloneDeep(this.ticketsPeriodFilterDefault);
        this.ticketsCurrentFilter = cloneDeep(this.ticketsCurrentFilterDefault);
        this.ticketsMultipleAssign = cloneDeep(this.ticketsMultipleAssignDefault);
        this.brigadeAssignData = cloneDeep(this.brigadeAssignDataDefault);

        if (countParameters === countExistsParameters && this.hasValidPeriodDates(params)) {
          if (isDevMode()) {
            console.log('~~~~ПОЛНОЕ ОБНОВЛЕНИЕ И ПОЛУЧЕНИЕ ЗАЯВОК~~~~');
          }

          const ticketsTypesIds = params.tickets_types_ids.split(',');
          const filteredTypesIds = this.authService.isGRSUser() ? '7' : ticketsTypesIds.filter((id) => id !== '7');
          this.childParams = cloneDeep(params);
          this.refreshAutomaticDistributionResultForCurrentDate();
          self.getPeriodFilterData(self.parentParams.sectorSelected.sector_id);

          // Если пришли query параметры, конвертируем их в matrix параметры
          this.navigate(
            {
              ...params,
              tickets_types_ids: filteredTypesIds,
            },
            isFromQueryParams // replaceUrl = true если пришли из query параметров
          );
        } else {
          if (isDevMode()) {
            console.log('~~~~СМЕНА РОУТИНГА~~~~');
          }

          self.navigateWithReplaceParams(Object.assign(this.childParams, params));
        }
      });
  }

  private getStatusesMultiData(): Observable<any> {
    const params = {
      role: this.isGRS ? SectorRole.GRRS : SectorRole.MT,
    };

    return new Observable((observer) => {
      this.ticketsAssignService.getTicketsMultipleStatuses(params).subscribe((response) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  private navigateWithReplaceParams(params) {
    const ps = cloneDeep(params);
    const ticketsPeriodFilterData = this.ticketsPeriodFilter.data;
    const pF = this.ticketsPeriodFilter;

    if (this.authService.isGRSUser()) {
      ps.tickets_types_ids = '7';
    }

    if (!this.hasValidPeriodDates(ps)) {
      ps.int_begin = this.moment(pF.dateRange.startDate.currentDate).format(this.dateFullFormat);
      ps.int_end = this.moment(pF.dateRange.endDate.currentDate).format(this.dateFullFormat);
    } else {
      ps.int_begin = this.moment(ps.int_begin).format(this.dateFullFormat);
      ps.int_end = this.moment(ps.int_end).format(this.dateFullFormat);
      this.initDates(pF);
    }

    if (ticketsPeriodFilterData.ticketsHdStatuses && ticketsPeriodFilterData.ticketsVkStatuses) {
      this.setDefaultStatuses(ps);
    }

    if (!ticketsPeriodFilterData.ticketsHdStatuses && !ticketsPeriodFilterData.ticketsVkStatuses) {
      this.loading = true;
      this.getStatusesMultiData().subscribe((response) => {
        ticketsPeriodFilterData.ticketsHdStatuses = response[0]['data'];
        ticketsPeriodFilterData.ticketsVkStatuses = response[1]['data'];

        const hdStatuses = ticketsPeriodFilterData.ticketsHdStatuses.map((s) => s.id);
        const vkStatuses = ticketsPeriodFilterData.ticketsVkStatuses.map((s) => s.id);

        ps.ticket_status = vkStatuses.join(',');
        ps.hd_ticket_status_group = hdStatuses.join(',');

        this.navigate(ps, true);
      });
    } else {
      this.navigate(ps, false);
    }
  }

  private navigate(params, isReplace): Promise<boolean> {
    const navigateTo = [WORK_SHIFT_PATHS.work_shift, WORK_SHIFT_PATHS.work_shift_s, this.parentParams.sectorSelected.sector_id]
      .concat(this.route.snapshot.data.navigateTo)
      .concat(params);

    return this.router.navigate(navigateTo, { replaceUrl: isReplace });
  }

  private hasValidPeriodDates(params): boolean {
    return !!params.int_begin && !!params.int_end && this.moment(params.int_begin).isValid() && this.moment(params.int_end).isValid();
  }

  private setDefaultStatuses(params): void {
    const ticketsPeriodFilterData = this.ticketsPeriodFilter.data;

    if (!params.ticket_status && ticketsPeriodFilterData.ticketsVkStatuses) {
      params.ticket_status = ticketsPeriodFilterData.ticketsVkStatuses.map((s) => s.id).join(',');
    }

    if (!params.hd_ticket_status_group && ticketsPeriodFilterData.ticketsHdStatuses) {
      params.hd_ticket_status_group = ticketsPeriodFilterData.ticketsHdStatuses.map((s) => s.id).join(',');
    }
  }

  private getPeriodFilterData(sector_id): void {
    this.loading = true;
    this.ticketsAssignService
      .getPeriodFilterData({
        sector_id,
        role: this.isGRS ? SectorRole.GRRS : SectorRole.MT,
      })
      .subscribe(
        (response) => {
          const periodFilter = this.ticketsPeriodFilter;

          periodFilter.data.districts = response[0].data.map((d) => {
            d.full_name = d.city.ct_name + ' - ' + d.district_name;
            return d;
          });
          periodFilter.data.ticketsVkStatuses = response[1].data;
          periodFilter.data.ticketsHdStatuses = response[2].data;
          if (this.authService.isGRSUser()) {
            periodFilter.data.ticketsTypes = response[3].data;
          } else {
            periodFilter.data.ticketsTypes = response[3].data.filter((tt) => !tt.name.includes('ГРРС'));
          }
          periodFilter.data.brigades = response[4].data;
          this.ticketsCurrentFilter.ticketsSettings = response[5].data;
          periodFilter.data.typeGPs = response[6].data;
          periodFilter.data.subtypeGPs = response[7].data;
          periodFilter.data.responsibleGroups = response[8].data;
          periodFilter.data.responsibleUsers = response[9].data;

          this.initCurrentFilterData();
        },
        (error) => {
          console.log(error);
          this.loading = false;
        }
      );
  }

  private makeDayAssigmentParams(): any {
    let assignDaySelected = this.ticketsCurrentFilter.assignDaySelected;

    return {
      sector_id: this.parentParams.sectorSelected.sector_id,
      int_begin: this.moment().add(assignDaySelected.countDays, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
      int_end: this.moment().add(assignDaySelected.countDays, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
    };
  }

  private makeTicketsParams(): any {
    let pF = this.ticketsPeriodFilter;
    let params = cloneDeep(this.childParams);

    let s = pF.dateRange.startDate.dateObj ? pF.dateRange.startDate.dateObj.dateMillis : pF.dateRange.startDate.initDate;
    let e = pF.dateRange.endDate.dateObj ? pF.dateRange.endDate.dateObj.dateMillis : pF.dateRange.endDate.initDate;

    params.sector_id = this.parentParams.sectorSelected.sector_id;
    params.int_begin = this.moment(s).format(this.dateFullFormat);
    params.int_end = this.moment(e).format(this.dateFullFormat);
    params.districts_ids = (pF.districtsSelected && pF.districtsSelected.map((i) => i.d_id)) || '';
    params.address = pF.address || '';
    params.tickets_types_ids = pF.ticketTypesSelected ? pF.ticketTypesSelected.map((i) => i.id) : this.isGRS ? [7] : [1, 2, 3, 4, 5, 6];
    params.brigades_ids = (pF.brigadesSelected && pF.brigadesSelected.map((i) => i.id)) || '';
    params.hd_ticket_number = pF.ticketNumber || '';
    params.ticket_status = (this.ticketsPeriodFilter.ticketsVkStatusesSelected && this.ticketsPeriodFilter.ticketsVkStatusesSelected.map((i) => i.id)) || '';
    params.hd_ticket_status_group = (this.ticketsPeriodFilter.ticketHdStatusesSelected && this.ticketsPeriodFilter.ticketHdStatusesSelected.map((i) => i.id)) || '';
    params.gp_types = (this.ticketsPeriodFilter.typeGPSelected && this.ticketsPeriodFilter.typeGPSelected.map((i) => i.id)) || '';
    params.gp_subtypes = (this.ticketsPeriodFilter.subtypeGPSelected && this.ticketsPeriodFilter.subtypeGPSelected.map((i) => i.id)) || '';
    params.responsible_groups = (this.ticketsPeriodFilter.responsibleGroupsSelected && this.ticketsPeriodFilter.responsibleGroupsSelected.map((i) => i.g_id)) || '';
    params.responsible_users = this.ticketsPeriodFilter.responsibleUsersSelected.map((i) => i.u_login);
    params.groups = this.isGRS ? [AuthGroupTypesEnum.ServiceEngineerGRS] : [AuthGroupTypesEnum.ServiceEngineer];

    return params;
  }

  get isGRS() {
    return this.authService.isGRSUser();
  }

  private initCurrentFilterState(): void {
    const currentFilter = this.ticketsCurrentFilter;
    const ticketsPeriodFilterData = this.ticketsPeriodFilter.data;
    const ticketsPeriodFilter = this.ticketsPeriodFilter;

    currentFilter.currentFilterTypeSelected = cloneDeep(currentFilter.currentFilterTypes.all);
    currentFilter.assignDaySelected = currentFilter.assignDaysList[0];
    ticketsPeriodFilter.address = this.childParams.address;
    ticketsPeriodFilter.ticketNumber = this.childParams.hd_ticket_number;

    this.initDates(ticketsPeriodFilter);
    this.initDistricts(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initVkStatuses(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initHdStatuses(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initGPTypes(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initGPSubTypes(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initResponsibleGroups(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initResponsibleUsers(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initTicketTypes(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initBrigades(ticketsPeriodFilter, ticketsPeriodFilterData);
  }

  private initCurrentFilterData(): void {
    this.initCurrentFilterState();
    this.getBrigadesAndTickets();
  }

  private initDates(ticketsPeriodFilter): void {
    ticketsPeriodFilter.dateRange.startDate.initDate = this.moment(this.childParams.int_begin)._d;
    ticketsPeriodFilter.dateRange.endDate.initDate = this.moment(this.childParams.int_end)._d;
  }

  private initDistricts(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    if (this.childParams.districts_ids) {
      const arr = this.childParams.districts_ids.split(',');
      const districts = [];

      each(ticketsPeriodFilterData.districts, (district) => {
        if (arr.indexOf(district.d_id + '') > -1) {
          districts.push(district);
        }
      });

      ticketsPeriodFilter.districtsSelected = districts;
    }
  }

  private initVkStatuses(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    if (this.childParams.ticket_status) {
      const arr = this.childParams.ticket_status.split(',');
      const statuses = [];

      each(ticketsPeriodFilterData.ticketsVkStatuses, (status) => {
        if (arr.indexOf(status.id + '') > -1) {
          statuses.push(status);
        }
      });

      ticketsPeriodFilter.ticketsVkStatusesSelected = statuses;
    }
  }

  private initHdStatuses(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    if (this.childParams.hd_ticket_status_group) {
      const arr = this.childParams.hd_ticket_status_group.split(',');
      const statuses = [];

      each(ticketsPeriodFilterData.ticketsHdStatuses, (status) => {
        if (arr.indexOf(status.id + '') > -1) {
          statuses.push(status);
        }
      });

      ticketsPeriodFilter.ticketHdStatusesSelected = statuses;
    }
  }

  private initGPTypes(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    const types = [];

    if (this.childParams.gp_types) {
      const arr = this.childParams.gp_types.split(',');

      each(ticketsPeriodFilterData.typeGPs, (typeGP) => {
        if (arr.indexOf(typeGP.id + '') > -1) {
          types.push(typeGP);
        }
      });
    }

    ticketsPeriodFilter.typeGPSelected = types;

    const appliedTypeGPs = cloneDeep(types.length ? types : ticketsPeriodFilterData.typeGPs);
    ticketsPeriodFilter.appliedTypeGPs = appliedTypeGPs.map((t) => ({
      ...t,
      selected: true,
    }));
  }

  private initGPSubTypes(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    const types = [];

    if (this.childParams.gp_subtypes) {
      const arr = this.childParams.gp_subtypes.split(',');

      each(ticketsPeriodFilterData.subtypeGPs, (typeGP) => {
        if (arr.indexOf(typeGP.id + '') > -1) {
          types.push(typeGP);
        }
      });
    }

    ticketsPeriodFilter.subtypeGPSelected = types;
    ticketsPeriodFilter.appliedSubtypeGPSelected = types;
    ticketsPeriodFilter.appliedSubtypeGPs = cloneDeep(types.length ? types : ticketsPeriodFilterData.subtypeGPs);
  }

  private initResponsibleGroups(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    const groups = [];

    if (this.childParams.responsible_groups) {
      const arr = this.childParams.responsible_groups.split(',');

      each(ticketsPeriodFilterData.responsibleGroups, (group) => {
        if (arr.indexOf(group.g_id + '') > -1) {
          groups.push(group);
        }
      });
    }

    ticketsPeriodFilter.responsibleGroupsSelected = groups;
  }

  private initResponsibleUsers(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    const users = [];

    if (this.childParams.responsible_users) {
      const arr = this.childParams.responsible_users.split(',');

      each(ticketsPeriodFilterData.responsibleUsers, (user) => {
        if (arr.indexOf(user.u_login + '') > -1) {
          users.push(user);
        }
      });
    }

    ticketsPeriodFilter.responsibleUsersSelected = users;
  }

  private initTicketTypes(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    if (this.childParams.tickets_types_ids) {
      const arr = this.childParams.tickets_types_ids.split(',');
      const types = [];

      each(ticketsPeriodFilterData.ticketsTypes, (type) => {
        if (arr.indexOf(type.id + '') > -1) {
          types.push(type);
        }
      });

      ticketsPeriodFilter.ticketTypesSelected = types;
    }
  }

  private initBrigades(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    if (this.childParams.brigades_ids) {
      const arr = this.childParams.brigades_ids.split(',');
      const brigades = [];

      each(ticketsPeriodFilterData.brigades, (brigade) => {
        if (arr.indexOf(brigade.id + '') > -1) {
          brigades.push(brigade);
        }
      });

      ticketsPeriodFilter.brigadesSelected = brigades;
    }
  }

  private getBrigadesForDayAssigment(params): Promise<any> {
    return new Promise((resolve, reject) => {
      this.ticketsAssignService.getBrigades(params).subscribe(
        (response) => {
          this.ticketsMultipleAssign.brigades = response.data.map((b) => {
            b.tickets_count = b.tickets_count || 0;
            return b;
          });
          this.changeBrigadesName();
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  private getTickets(params): Promise<any> {
    return new Promise((resolve, reject) => {
      this.ticketsAssignService.getTickets(params).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  private getBrigadesAndTickets(): void {
    const brigades = this.getBrigadesForDayAssigment(this.makeDayAssigmentParams());
    const tickets = this.getTickets(this.makeTicketsParams());
    let timerId = null;

    this.tickets.ticketsLoading = true;
    this.tickets.data = null;
    this.tickets.dataFlatList = null;
    this.tickets.dataMatrix = null;
    this.tickets.dataTable = null;

    Promise.all([brigades, tickets]).then(
      (response) => {
        this.ticketsMultipleAssign.brigades = null;

        this.ticketsMultipleAssign.brigades = response[0].data;
        this.tickets = {
          ...this.tickets,
          data: response[1].data,
        };

        this.resetTicketStatus();
        this.makeTicketsFormat();
        this.changeBrigadesName();
        this.recalculate();

        console.log('TicketsAssignNewComponent: data loaded successfully, setting loading = false');
        console.log('TicketsAssignNewComponent: tickets data:', this.tickets.data);
        console.log('TicketsAssignNewComponent: ticketsPage value:', this.ticketsPage);
        console.log('TicketsAssignNewComponent: route snapshot data:', this.route.snapshot.data);
        this.loading = false;
        this.tickets.ticketsLoading = false;
        console.log('TicketsAssignNewComponent: loading set to false, should show content now');

        timerId = setTimeout(() => {
          if (timerId) {
            clearTimeout(timerId);
          }

          if (this.ticketsMatrixComponent) {
            this.ticketsMatrixComponent.setEllipsis();
          }
        });
      },
      (error) => {
        console.log(error);
        this.loading = false;
        this.tickets.ticketsLoading = false;
      }
    );
  }

  private getTicketsLineInfo() {
    const tickets = this.getTicketsForLineInfo();

    this.ticketViewService.getHdAbonentStatus({ abon_info: tickets }).subscribe(
      (response) => {
        this.setLineInfoToTickets(response.data);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  private getTicketsForLineInfo() {
    const tickets = [];
    const ticketTypes = [1, 2, 3];

    each(this.tickets.dataFlatList, (ticket) => {
      if (ticketTypes.indexOf(ticket.ticket_type.id) > -1) {
        tickets.push({
          ticket_id: ticket.id,
          login: ticket.ticket_login || '',
        });
      }
    });

    return tickets;
  }

  private setLineInfoToTickets(tickets) {
    const dataFlatList = this.tickets.dataFlatList;
    each(tickets, (ticket) => {
      const index = findIndex(dataFlatList, (t: any) => t.id === ticket.ticket_id);

      if (index > -1) {
        dataFlatList[index].hd_line_status_info = this.mapNetworkStatus(ticket.code);
      }
    });
  }

  private mapNetworkStatus(code: number | null | undefined): number | null {
    if (code == null) {
      return null;
    }
    if ([1, 2, 3, 4].indexOf(code) > -1) {
      return 1;
    }
    return 0;
  }

  private resetTicketStatus(): void {
    const statuses = this.ticketsCurrentFilter.currentFilterTypes;

    statuses.assigned.counts = 0;
    statuses.unassigned.counts = 0;
    statuses.needActions.counts = 0;
    statuses.opened.counts = 0;
    statuses.all.counts = 0;
  }

  private makeTicketsFormat(): void {
    this.tickets.dataTable = [];
    this.tickets.dataFlatList = [];
    this.tickets.dataMatrix = [];

    each(this.tickets.data, (date) => {
      date.isShow = true;
      const dateInTable = this.addDateToTable(date);

      each(date.intervals, (interval) => {
        interval.isGPInterval = interval.commutator_fail_block;
        interval.isOpen = true;
        interval.ticketsCount = 0;
        interval.isShow = true;

        each(interval.districts, (district) => {
          district.isOpened = true;
          district.isShow = true;
          interval.ticketsCount += (district.tickets && district.tickets.length) || 0;

          each(district.tickets, (ticket) => {
            ticket.isChecked = false;
            ticket.isShow = true;
            ticket.district_name = ticket.district.district_name;
            ticket.brigade_default = cloneDeep(ticket.brigade);
            ticket.hd_line_status_info = this.mapNetworkStatus(ticket.extra_flags && ticket.extra_flags.network_status);

            this.addTicketToFlatList(ticket);
            this.countTicketOnBrigade(ticket);
            this.addTicketToMatrixList(date.date, ticket);
            this.addTicketToTable(dateInTable, interval, district, ticket);
          });
        });
      });
    });

    this.sortingMatrixList();
    this.sortingLineList();
  }

  private addDateToTable(date) {
    if (!this.tickets.dataTable) {
      this.tickets.dataTable = [];
    }

    const newDate = {
      date: date.date,
      intervals: [],
      gp_intervals: [],
      edo_intervals: [],
      isShow: true,
    };

    this.tickets.dataTable.push(newDate);
    return newDate;
  }

  /**
   * Добавляет в структуру таблицы в указанную дату заявку.
   *  - если интервала еще не было, добавит интервал
   *  - если в интервале не было дистрикта, добавит дистрикт.
   * Т.о. заявки разных групп могут быть в разных интервалах и дистриктах.
   *
   * @param dateTable
   * @param interval
   * @param district
   * @param ticket
   */
  private addTicketToTable(dateTable, interval, district, ticket) {
    const isGPIntervalTicket = this.ticketsService.checkGPInterval(ticket.hd_schedule_intbegin, ticket.hd_schedule_intend);

    // выбор списка интервалов
    let tableIntervals = dateTable.intervals; // помойка заявок
    if (isGPIntervalTicket) {
      // авария
      tableIntervals = dateTable.gp_intervals;
    } else if (ticket.ticket_type.id === 5) {
      // исправление договора
      tableIntervals = dateTable.edo_intervals;
    }

    // поиск интервала
    // для заявок "исправление договора" считаем один условный интервал
    // (т.е. визуально отображать в одном интервале)
    let tableInterval;
    if (ticket.ticket_type.id !== 5) {
      tableInterval = find(tableIntervals, (intrv) => {
        return intrv.int_begin === interval.int_begin && intrv.int_end === interval.int_end;
      });
    } else {
      tableInterval = tableIntervals[0];
    }

    if (!tableInterval) {
      let int_begin = interval.int_begin;
      let int_end = interval.int_end;
      if (ticket.ticket_type === 5) {
        int_begin = null;
        int_end = null;
      }
      tableInterval = {
        int_begin: int_begin,
        int_end: int_end,
        districts: [],
        isOpen: true,
        isShow: true,
        ticketsCount: 0,
      };

      tableIntervals.push(tableInterval);
    }

    tableInterval.ticketsCount++;

    // поиск района
    let tableDistrict: any = find(tableInterval.districts, {
      district_name: district.district_name,
    });

    if (!tableDistrict) {
      tableDistrict = {
        city_name: district.city_name,
        district_name: district.district_name,
        tickets: [],
        isOpened: true,
        isShow: true,
        all: 0,
        assigned: 0,
      };

      tableInterval.districts.push(tableDistrict);
    }

    // добавление заявки в район
    tableDistrict.tickets.push(ticket);
    tableDistrict.all++;
    if (ticket.brigade) {
      tableDistrict.assigned++;
    }
  }

  private recalculateStatusAndTickets(isVisibleFn: (ticket) => boolean = identity): void {
    each(this.tickets.data, (date) => {
      each(date.intervals, (interval) => {
        each(interval.districts, (district) => {
          each(district.tickets, (ticket) => {
            if (isVisibleFn(ticket)) {
              this.countTicketStatus(ticket);
              this.countTicketOnBrigade(ticket);
            }
          });
        });
      });
    });
  }

  private filteringTicketsByStatus(): void {
    this.filteringListByStatus();
    this.filteringMatrixByStatus();

    // Создаем новую ссылку на объект tickets для принудительного обновления дочерних компонентов
    this.tickets = cloneDeep(this.tickets);
  }

  private filteringListByStatus() {
    let isExistOneVisibleInterval = false;
    let isExistOneVisibleDistrict = false;
    let isExistOneVisibleTicket = false;

    each(this.tickets.data, (date) => {
      isExistOneVisibleInterval = false;

      each(date.intervals, (interval) => {
        isExistOneVisibleDistrict = false;

        each(interval.districts, (district) => {
          isExistOneVisibleTicket = false;

          each(district.tickets, (ticket) => {
            ticket.isShow = this.checkShowTicket(ticket);

            if (ticket.isShow) {
              isExistOneVisibleTicket = true;
            }
          });

          district.isShow = isExistOneVisibleTicket;

          if (isExistOneVisibleTicket) {
            isExistOneVisibleDistrict = true;
          }
        });

        interval.isShow = isExistOneVisibleDistrict;

        if (isExistOneVisibleDistrict) {
          isExistOneVisibleInterval = true;
        }
      });

      date.isShow = isExistOneVisibleInterval;
    });
  }

  private filteringMatrixByStatus() {
    let isExistOneVisibleGPIntervalTicket = false;
    let isExistOneVisibleEDOIntervalTicket = false;
    let isExistOneVisibleInterval = false;
    let isExistOneVisibleTicket = false;

    each(this.tickets.dataMatrix, (date) => {
      isExistOneVisibleInterval = false;
      isExistOneVisibleGPIntervalTicket = false;
      isExistOneVisibleEDOIntervalTicket = false;

      // Обработка GP интервалов (аварии)
      each(date.gp_intervals.tickets, (ticket) => {
        ticket.isShow = this.checkShowTicket(ticket);

        if (ticket.isShow) {
          isExistOneVisibleGPIntervalTicket = true;
        }
      });

      date.gp_intervals.isShow = isExistOneVisibleGPIntervalTicket;

      // Обработка EDO интервалов (исправление договора)
      each(date.edo_intervals.tickets, (ticket) => {
        ticket.isShow = this.checkShowTicket(ticket);

        if (ticket.isShow) {
          isExistOneVisibleEDOIntervalTicket = true;
        }
      });

      date.edo_intervals.isShow = isExistOneVisibleEDOIntervalTicket;

      // Обработка обычных интервалов
      each(date.intervals.intervals, (interval) => {
        isExistOneVisibleTicket = false;

        each(interval.tickets, (ticket) => {
          ticket.isShow = this.checkShowTicket(ticket);

          if (ticket.isShow) {
            isExistOneVisibleTicket = true;
          }
        });

        interval.isShow = isExistOneVisibleTicket;

        if (isExistOneVisibleTicket) {
          isExistOneVisibleInterval = true;
        }
      });

      // Дата показывается, если есть хотя бы один видимый интервал любого типа
      date.isShow = isExistOneVisibleInterval || isExistOneVisibleGPIntervalTicket || isExistOneVisibleEDOIntervalTicket;
    });
  }

  private checkShowTicket(ticket): boolean {
    const currentFilterTypeSelected = this.ticketsCurrentFilter.currentFilterTypeSelected;
    const statuses = this.ticketsCurrentFilter.currentFilterTypeSelected.ticketStatuses;
    const isAssigned = this.isTicketAssigned(ticket);

    if (currentFilterTypeSelected.id === 'opened') {
      const isShowByStatusTicket = statuses.indexOf(ticket.hd_ticket_status.id) > -1;
      return isShowByStatusTicket;
    }

    if (currentFilterTypeSelected.id === 'assigned') {
      return isAssigned;
    }

    if (currentFilterTypeSelected.id === 'unassigned') {
      const isShowByStatusTicket = this.isGRS
        ? (!ticket.departures || ticket.departures.length === 0) && ticket.hd_ticket_status.id === 14
        : statuses.indexOf(ticket.ticket_status.id) > -1;
      return isShowByStatusTicket && !isAssigned;
    }

    if (currentFilterTypeSelected.id === 'needActions') {
      return statuses.indexOf(ticket.ticket_status.id) > -1;
    }

    if (currentFilterTypeSelected.id === 'all') {
      return true;
    }
  }

  private addTicketToFlatList(ticket: any): void {
    if (!this.tickets.dataFlatList) {
      this.tickets.dataFlatList = [];
    }

    this.tickets.dataFlatList.push(ticket);
  }

  private countTicketStatus(ticket): void {
    const currentFilterTypes = this.ticketsCurrentFilter.currentFilterTypes;
    const isAssigned = this.isTicketAssigned(ticket);

    if (currentFilterTypes.opened.ticketStatuses.indexOf(ticket.hd_ticket_status.id) > -1) {
      currentFilterTypes.opened.counts++;
    }

    if (isAssigned) {
      currentFilterTypes.assigned.counts++;
    }

    const isUnassigned = this.isGRS
      ? (!ticket.departures || ticket.departures.length === 0) && ticket.hd_ticket_status.id === 14
      : currentFilterTypes.unassigned.ticketStatuses.indexOf(ticket.ticket_status.id) > -1;

    if (isUnassigned && !isAssigned) {
      currentFilterTypes.unassigned.counts++;
    }

    if (currentFilterTypes.needActions.ticketStatuses.indexOf(ticket.ticket_status.id) > -1) {
      currentFilterTypes.needActions.counts++;
    }

    currentFilterTypes.all.counts++;
  }

  private countTicketOnBrigade(ticket): void {
    const brigades = this.ticketsMultipleAssign.brigades;
    const assignDayMillis = this.moment().add(this.ticketsCurrentFilter.assignDaySelected.countDays, 'day').startOf('day').valueOf();
    const endDayMillis = this.moment()
      .add(this.ticketsCurrentFilter.assignDaySelected.countDays + this.ticketsCurrentFilter.ticketsSettings.days_for_assignment, 'day')
      .endOf('day')
      .valueOf();
    const ticketMillis = +new Date(ticket.hd_schedule_date);

    if (((ticket.brigade && ticket.brigade.id) || (ticket.brigade && ticket.brigade_id)) && ticketMillis >= assignDayMillis && ticketMillis <= endDayMillis) {
      const brigadeIndex = findIndex(brigades, (b: any) => b.id === ticket.brigade.id);

      if (brigadeIndex > -1) {
        brigades[brigadeIndex].tickets_count += 1;
      }
    }
  }

  private getTicketInterval(date): any {
    const intervals = this.intervals;
    let interval = null;

    each(intervals, (int: any) => {
      const ticketDate = this.moment(date);
      const ticketDateMillis = ticketDate.hours() * 60 * 60 + ticketDate.minutes() * 60 + ticketDate.millisecond();
      const startDateMillis = int.startTime.hours * 60 * 60 + int.startTime.minutes * 60 + int.startTime.seconds;
      const endDateMillis = int.endTime.hours * 60 * 60 + int.endTime.minutes * 60 + int.endTime.seconds;

      if (ticketDateMillis >= startDateMillis && ticketDateMillis <= endDateMillis) {
        interval = { index: int.index, interval: int.interval };
      }
    });

    return interval;
  }

  private makeIntervals(): any[] {
    let intervals = [];

    each(this.intervals, (interval) => {
      intervals.push({ interval: interval.interval, tickets: [] });
    });

    return intervals;
  }

  private addTicketToMatrixList(date, ticket): void {
    let ticketsOnDate = this.tickets;
    let dateIndex;
    const interval = this.getTicketInterval(ticket.hd_schedule_intbegin);
    const isGPIntervalTicket = this.ticketsService.checkGPInterval(ticket.hd_schedule_intbegin, ticket.hd_schedule_intend);

    if (!ticketsOnDate.dataMatrix) {
      ticketsOnDate.dataMatrix = [];
    }

    dateIndex = findIndex(ticketsOnDate.dataMatrix, (i: any) => i.date === date);

    if (dateIndex === -1) {
      ticketsOnDate.dataMatrix.push({
        date,
        gp_intervals: { isShow: true, isOpen: true, tickets: [] },
        edo_intervals: { isShow: true, isOpen: true, tickets: [] },
        intervals: { isShow: true, intervals: this.makeIntervals() },
      });
    }

    dateIndex = findIndex(ticketsOnDate.dataMatrix, (i: any) => i.date === date);

    if (ticket.ticket_type.id === 5) {
      if (this.ticketsCurrentFilter.ticketsSettings.days_alert_to_correct_contract) {
        // если до конца интервала меньше дней чем days_alert_to_correct_contract
        // то интервал надо подсветить
        const startDate = this.moment(ticket.hd_schedule_intend, 'YYYY-MM-DDThh:mm:ss');
        const endDate = this.moment(this.ticketsCurrentFilter.ticketsSettings.sys_date, 'YYYY-MM-DDThh:mm:ss');
        const diff = this.moment(startDate).diff(endDate);
        const diffDays = this.moment.duration(diff).asDays();

        ticket.isWarnExpDays = diffDays < this.ticketsCurrentFilter.ticketsSettings.days_alert_to_correct_contract;
      }

      ticketsOnDate.dataMatrix[dateIndex].edo_intervals.tickets.push(ticket);
    } else if (isGPIntervalTicket) {
      ticketsOnDate.dataMatrix[dateIndex].gp_intervals.tickets.push(ticket);
    } else {
      ticketsOnDate.dataMatrix[dateIndex].intervals.intervals[interval.index].tickets.push(ticket);
    }
  }

  private sortingMatrixList(): void {
    let tickets = this.tickets;

    each(tickets.dataMatrix, (date) => {
      date.gp_intervals.tickets = orderBy(date.gp_intervals.tickets, ['district_name', 'hd_schedule_intbegin', 'hd_ticket_number'], ['asc', 'asc', 'asc']);
      each(date.gp_intervals.tickets, (ticket: any, index: number) => {
        if (index + 1 > 6) {
          let idx = (index + 1) % 6;
          ticket._index = idx === 0 ? 6 : idx;
        } else {
          ticket._index = index + 1;
        }
      });

      date.edo_intervals.tickets = orderBy(date.edo_intervals.tickets, ['hd_schedule_intbegin'], ['asc']);
      each(date.edo_intervals.tickets, (ticket: any, index: number) => {
        if (index + 1 > 6) {
          let idx = (index + 1) % 6;
          ticket._index = idx === 0 ? 6 : idx;
        } else {
          ticket._index = index + 1;
        }
      });

      each(date.intervals.intervals, (interval) => {
        interval.tickets = orderBy(interval.tickets, ['district_name', 'hd_schedule_intbegin', 'hd_ticket_number'], ['asc', 'asc', 'asc']);
      });
    });

    tickets.dataMatrix = orderBy(tickets.dataMatrix, ['date'], ['asc']);
  }

  private sortingLineList(): void {
    each(this.tickets.data, (date) => {
      each(date.intervals, (interval) => {
        each(interval.districts, (district) => {
          district.tickets = orderBy(district.tickets, ['hd_ticket_number'], ['asc']);
        });
      });
    });
  }

  private changeBrigadesName(): void {
    each(this.ticketsMultipleAssign.brigades, (b) => {
      b.brigade_name_merged = b.brigade_name + (b.tickets_count > 0 ? '(' + b.tickets_count + ')' : '');
    });
  }

  public applyPeriodFilter() {
    if (isDevMode()) {
      console.log('APPLY FILTER ~~~~~~~~~~~~', this);
    }

    let params = cloneDeep(this.makeTicketsParams());
    let oldParams = cloneDeep(this.childParams);
    params.ticket_status = (params.ticket_status && params.ticket_status.join(',')) || '';
    params.hd_ticket_status_group = (params.hd_ticket_status_group && params.hd_ticket_status_group.join(',')) || '';
    params.districts_ids = (params.districts_ids && params.districts_ids.join(',')) || '';
    params.tickets_types_ids = (params.tickets_types_ids && params.tickets_types_ids.join(',')) || '';
    params.brigades_ids = (params.brigades_ids && params.brigades_ids.join(',')) || '';
    params.gp_types = (params.gp_types && params.gp_types.join(',')) || '';
    params.gp_subtypes = (params.gp_subtypes && params.gp_subtypes.join(',')) || '';
    params.responsible_groups = (params.responsible_groups && params.responsible_groups.join(',')) || '';
    params.responsible_users = (params.responsible_users && params.responsible_users.join(',')) || '';

    if (isEqual(oldParams, params)) {
      if (isDevMode()) {
        console.log('~~~~ПАРАМЕТРЫ НЕ ОТЛИЧАЮТСЯ, НУЖНО ПУЛУЧАТЬ ДАННЫЕ~~~~');
      }

      this.canDeactivate().then((res) => {
        if (res) {
          this.getBrigadesAndTickets();
        }
      });
    } else {
      if (isDevMode()) {
        console.log('~~~~ПАРАМЕТРЫ ОТЛИЧАЮТСЯ, НУЖНО СДЕЛАТЬ РЕДИРЕКТ~~~~');
      }

      this.navigate(params, false);
    }
  }

  public resetPeriodFilter() {
    if (isDevMode()) {
      console.log('RESET FILTER ~~~~~~~~~~~~', this);
      console.log('~~~~ПАРАМЕТРЫ ОТЛИЧАЮТСЯ, НУЖНО СДЕЛАТЬ РЕДИРЕКТ~~~~');
    }

    const params = this.makeResetPeriodParams();

    this.resetPeriodFilterState(params);
    this.navigate(params, true).then((isNavigated) => {
      if (!isNavigated) {
        this.getBrigadesAndTickets();
      }
    });
  }

  private makeResetPeriodParams(): any {
    const params = cloneDeep(this.childParamsDefault);
    const dateRange = this.ticketsPeriodFilter.dateRange;

    params.int_begin = this.moment(dateRange.startDate.currentDate).format(this.dateFullFormat);
    params.int_end = this.moment(dateRange.endDate.currentDate).format(this.dateFullFormat);

    if (this.authService.isGRSUser()) {
      params.tickets_types_ids = '7';
    }

    this.setDefaultStatuses(params);

    return params;
  }

  private resetPeriodFilterState(params): void {
    const ticketsPeriodFilterData = this.ticketsPeriodFilter.data;
    const ticketsSettings = this.ticketsCurrentFilter.ticketsSettings;

    this.childParams = cloneDeep(params);
    this.ticketsPeriodFilter = cloneDeep(this.ticketsPeriodFilterDefault);
    this.ticketsPeriodFilter.data = ticketsPeriodFilterData;
    this.ticketsCurrentFilter = cloneDeep(this.ticketsCurrentFilterDefault);
    this.ticketsCurrentFilter.ticketsSettings = ticketsSettings;
    this.ticketsMultipleAssign = cloneDeep(this.ticketsMultipleAssignDefault);
    this.brigadeAssignData = cloneDeep(this.brigadeAssignDataDefault);

    this.initCurrentFilterState();
  }

  public exportPeriodFilter() {
    const params = this.makeTicketsParams();

    this.ticketsAssignService.downloadTickets(params).subscribe();
  }

  public startAutomaticDistributionScenario(): void {
    if (this.automaticDistribution.isChecking || this.automaticDistribution.isRunning) {
      return;
    }

    this.automaticDistribution.isChecking = true;
    this.automaticDistribution.resultError = null;

    this.ticketsAssignService.checkAutomaticDistribution(this.makeAutomaticDistributionParams(true)).subscribe(
      (response) => {
        if (this.isAutomaticDistributionPositiveResult(response)) {
          this.openAutomaticDistributionRepeatConfirm();
        } else {
          this.openAutomaticDistributionSettings();
        }
      },
      (error) => {
        if (error && error.status === 500) {
          this.openAutomaticDistributionSettings();
          return;
        }

        this.automaticDistribution.isChecking = false;
        this.openAutomaticDistributionUnavailableModal(false);
      }
    );
  }

  private openAutomaticDistributionRepeatConfirm(): void {
    const confirmDialog = this.modalService.open(ConfirmModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });

    confirmDialog.componentInstance.title = 'Автоматическое распределение';
    confirmDialog.componentInstance.description = 'По данному участку уже производилось распределение.';
    confirmDialog.componentInstance.successButtonName = 'Продолжить';
    confirmDialog.componentInstance.abortButtonName = 'Отмена';

    confirmDialog.result.then(
      () => {
        this.openAutomaticDistributionSettings(true);
      },
      () => {
        this.automaticDistribution.isChecking = false;
      }
    );
  }

  private openAutomaticDistributionSettings(alreadyDistributedToday = false): void {
    this.automaticDistribution.isChecking = false;

    const settingsDialog = this.modalService.open(AutomaticDistributionSettingsModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper modal-wrapper--w-680',
      backdrop: 'static',
    });

    settingsDialog.componentInstance.alreadyDistributedToday = alreadyDistributedToday;
    settingsDialog.componentInstance.sectorId = this.parentParams.sectorSelected && this.parentParams.sectorSelected.sector_id;
    settingsDialog.componentInstance.distributionDate = this.getAutomaticDistributionDate();

    settingsDialog.result.then(
      (settings) => {
        this.runAutomaticDistribution(settings);
      },
      () => {}
    );
  }

  private runAutomaticDistribution(settings): void {
    const isAnalysis = settings && settings.scenario === 'analysis';
    const payload = Object.assign({}, this.makeAutomaticDistributionParams(true), {
      allow_unassigned: !!(settings && settings.allow_unassigned),
      assign_after_result: isAnalysis ? false : !!(settings && settings.assign_after_result),
      distribution_strategy: (settings && settings.distribution_strategy) || 'minimize_total_travel_time',
      limitation_type: [1, 2, 3].indexOf(Number(settings && settings.limitation_type)) > -1 ? Number(settings.limitation_type) : 1,
      employees: ((settings && settings.employees) || []).map((employee) => {
        const payloadEmployee = {
          user_id: employee.user_id,
          movement_type: employee.movement_type,
          coordinate_type: employee.coordinate_type,
          // Сохраняется бэкендом в результате для повторного открытия распределения.
          is_trip: !!employee.is_trip,
          personnel_number: employee.personnel_number,
        };
        // Время смены: у обычных сотрудников из графика, у командировочных его вводит диспетчер.
        // Бэкенд принимает только «hh:mm», поэтому нули у командировочных без ввода не отправляем
        const shiftBegin = this.toShiftTime(employee.int_begin);
        const shiftEnd = this.toShiftTime(employee.int_end);

        if (shiftBegin) {
          Object.assign(payloadEmployee, { int_begin: shiftBegin });
        }
        if (shiftEnd) {
          Object.assign(payloadEmployee, { int_end: shiftEnd });
        }

        // district_ids — только у командировочных: районы участка, куда их можно ставить.
        // У остальных это поле приходит с бэкенда с их закреплением, его не пересылаем
        if (employee.is_trip && employee.district_ids) {
          Object.assign(payloadEmployee, { district_ids: employee.district_ids });
        }

        return payloadEmployee;
      }),
    });
    const ticketStatuses = ((settings && settings.ticket_status) || []).map((status) => Number(status)).filter((status) => Number.isFinite(status));

    if (isAnalysis && ticketStatuses.length) {
      Object.assign(payload, { ticket_status: ticketStatuses });
    }

    this.automaticDistribution.isRunning = true;
    this.automaticDistribution.hasResult = false;
    this.automaticDistribution.resultError = null;
    this.automaticDistribution.analysisLoading = false;
    this.automaticDistribution.analysisError = null;
    this.automaticDistribution.transactionId = null;
    this.automaticDistribution.transactionDate = payload.date;
    this.automaticDistribution.lastSettings = settings;
    this.automaticDistribution.isSavingResult = false;
    this.automaticDistribution.saveResultError = null;
    this.automaticDistribution.saveResultSuccess = false;
    this.stopAutomaticDistributionAnalysisPolling();

    const startRequest = isAnalysis
      ? this.ticketsAssignService.startAutomaticDistributionRecalculate(payload)
      : this.ticketsAssignService.startAutomaticDistribution(payload);

    startRequest.subscribe(
      (response) => {
        const transactionId = this.getAutomaticDistributionTransactionId(response);

        if (!transactionId) {
          this.openAutomaticDistributionUnavailableModal(true);
          return;
        }

        this.automaticDistribution.transactionId = transactionId;
        this.openAutomaticDistributionProgressModal();
        this.pollAutomaticDistributionStatus(transactionId);
      },
      () => {
        this.openAutomaticDistributionUnavailableModal(true);
      }
    );
  }

  private openAutomaticDistributionProgressModal(): void {
    this.ignoreAutomaticDistributionProgressClose = false;
    this.automaticDistributionProgressModalRef = this.modalService.open(AutomaticDistributionProgressModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
      keyboard: false,
    });

    this.automaticDistributionProgressModalRef.result.then(
      () => {
        this.handleAutomaticDistributionProgressClosed();
      },
      () => {
        this.handleAutomaticDistributionProgressClosed();
      }
    );
  }

  private handleAutomaticDistributionProgressClosed(): void {
    if (this.ignoreAutomaticDistributionProgressClose) {
      this.ignoreAutomaticDistributionProgressClose = false;
      return;
    }

    this.cancelAutomaticDistributionScenario();
  }

  private pollAutomaticDistributionStatus(transactionId): void {
    if (
      !this.automaticDistribution.isRunning ||
      String(this.automaticDistribution.transactionId) !== String(transactionId)
    ) {
      return;
    }

    this.ticketsAssignService.getAutomaticDistributionStatus(transactionId).subscribe(
      (response) => {
        if (
          !this.automaticDistribution.isRunning ||
          String(this.automaticDistribution.transactionId) !== String(transactionId)
        ) {
          return;
        }

        if (this.isAutomaticDistributionPositiveResult(response)) {
          this.finishAutomaticDistributionScenario();
          return;
        }

        this.automaticDistributionPollingTimerId = setTimeout(() => {
          this.automaticDistributionPollingTimerId = null;
          this.pollAutomaticDistributionStatus(transactionId);
        }, this.automaticDistributionPollingIntervalMs);
      },
      () => {
        if (
          !this.automaticDistribution.isRunning ||
          String(this.automaticDistribution.transactionId) !== String(transactionId)
        ) {
          return;
        }

        this.openAutomaticDistributionUnavailableModal(true);
      }
    );
  }

  private finishAutomaticDistributionScenario(): void {
    const isPreviewMode = this.isAutomaticDistributionPreviewMode();

    this.stopAutomaticDistributionPolling();
    this.automaticDistribution.isRunning = false;
    this.automaticDistribution.hasResult = true;
    this.closeAutomaticDistributionProgressModal();

    if (isPreviewMode) {
      this.automaticDistribution.showMap = true;
      this.automaticDistribution.showSchedule = false;
    } else {
      this.getBrigadesAndTickets();
    }

    this.loadAutomaticDistributionResult(false);
  }

  // Бэкенд принимает время смены только как «hh:mm»: нули, пустые и прочие значения отбрасываем
  private toShiftTime(value): string | null {
    const match = String(value === null || value === undefined ? '' : value).match(/^(\d{2}:\d{2})/);

    return match ? match[1] : null;
  }

  private isAutomaticDistributionPreviewMode(): boolean {
    const settings = this.automaticDistribution && this.automaticDistribution.lastSettings;

    if (!settings) {
      return false;
    }

    if (settings.launch_mode) {
      return settings.launch_mode === 'preview';
    }

    return settings.assign_after_result === false;
  }

  private saveAutomaticDistributionResult(): void {
    const transactionId = this.automaticDistribution && this.automaticDistribution.transactionId;

    if (!transactionId || this.automaticDistribution.isSavingResult) {
      return;
    }

    this.automaticDistribution.isSavingResult = true;
    this.automaticDistribution.saveResultError = null;
    this.automaticDistribution.saveResultSuccess = false;

    this.ticketsAssignService.assignAutomaticDistributionResult({ transaction_id: String(transactionId) }).subscribe(
      (response) => {
        if (this.isAutomaticDistributionNegativeResult(response)) {
          this.automaticDistribution.isSavingResult = false;
          this.automaticDistribution.saveResultError = 'Не удалось сохранить распределение.';
          return;
        }

        this.automaticDistribution.isSavingResult = false;
        this.automaticDistribution.saveResultSuccess = true;
        if (this.automaticDistribution.result) {
          this.automaticDistribution.result = Object.assign({}, this.automaticDistribution.result, {
            is_applied: true,
          });
        }
        this.getBrigadesAndTickets();
      },
      () => {
        this.automaticDistribution.isSavingResult = false;
        this.automaticDistribution.saveResultError = 'Не удалось сохранить распределение.';
      }
    );
  }

  private cancelAutomaticDistributionScenario(): void {
    this.stopAutomaticDistributionPolling();
    this.automaticDistribution.isRunning = false;
  }

  private closeAutomaticDistributionProgressModal(): void {
    if (!this.automaticDistributionProgressModalRef) {
      return;
    }

    this.ignoreAutomaticDistributionProgressClose = true;
    this.automaticDistributionProgressModalRef.close(true);
    this.automaticDistributionProgressModalRef = null;
  }

  private stopAutomaticDistributionPolling(): void {
    if (this.automaticDistributionPollingTimerId) {
      clearTimeout(this.automaticDistributionPollingTimerId);
      this.automaticDistributionPollingTimerId = null;
    }
  }

  private openAutomaticDistributionUnavailableModal(retryAllowed: boolean): void {
    this.stopAutomaticDistributionPolling();
    this.automaticDistribution.isChecking = false;
    this.automaticDistribution.isRunning = false;
    this.closeAutomaticDistributionProgressModal();

    const errorDialog = this.modalService.open(ConfirmModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });

    errorDialog.componentInstance.title = 'Ошибка';
    errorDialog.componentInstance.description = 'Распределение временно недоступно обратитесь к администратору.';
    errorDialog.componentInstance.successButtonName = retryAllowed ? 'Повторить' : null;
    errorDialog.componentInstance.abortButtonName = 'OK';

    errorDialog.result.then(
      () => {
        if (retryAllowed && this.automaticDistribution.lastSettings) {
          this.runAutomaticDistribution(this.automaticDistribution.lastSettings);
        }
      },
      () => {}
    );
  }

  private toggleAutomaticDistributionMap(): void {
    const shouldShowMap = !this.automaticDistribution.showMap;

    this.automaticDistribution.showMap = shouldShowMap;
    this.automaticDistribution.showSchedule = false;

    if (this.automaticDistribution.showMap) {
      this.loadAutomaticDistributionResult(true);
    }
  }

  private toggleAutomaticDistributionSchedule(): void {
    const shouldShowSchedule = !this.automaticDistribution.showSchedule;

    this.automaticDistribution.showSchedule = shouldShowSchedule;
    this.automaticDistribution.showMap = false;

    if (this.automaticDistribution.showSchedule) {
      this.loadAutomaticDistributionResult(true);
    }
  }

  private loadAutomaticDistributionResult(showError: boolean): void {
    this.loadAutomaticDistributionOriginalTickets();

    if (this.automaticDistributionResultSubscription) {
      this.automaticDistributionResultSubscription.unsubscribe();
    }

    this.stopAutomaticDistributionAnalysisPolling();

    const params = this.makeAutomaticDistributionResultParams();
    const requestDate = params.date;

    this.automaticDistribution.resultLoading = true;
    this.automaticDistribution.resultError = null;
    this.automaticDistribution.analysisError = null;

    this.automaticDistributionResultSubscription = this.ticketsAssignService.getAutomaticDistributionResult(params).subscribe(
      (response) => {
        if (requestDate !== this.getAutomaticDistributionDate()) {
          return;
        }

        this.automaticDistribution.result = this.getAutomaticDistributionResultData(response);
        this.automaticDistribution.resultDate = requestDate;
        this.syncAutomaticDistributionTransactionFromResult(response, requestDate);
        this.automaticDistribution.resultLoading = false;
        this.automaticDistributionResultSubscription = null;
        this.pollAutomaticDistributionUnassignedOrderAnalysis(requestDate);
      },
      () => {
        if (requestDate !== this.getAutomaticDistributionDate()) {
          return;
        }

        this.automaticDistribution.resultLoading = false;
        this.automaticDistributionResultSubscription = null;

        if (showError) {
          this.automaticDistribution.resultError = 'Не удалось загрузить результат автоматического распределения.';
        }
      }
    );
  }

  private syncAutomaticDistributionTransactionFromResult(response, requestDate: string): void {
    const transactionId = this.getAutomaticDistributionTransactionId(response);

    if (!transactionId) {
      return;
    }

    this.automaticDistribution.transactionId = transactionId;
    this.automaticDistribution.transactionDate = requestDate;
  }

  private pollAutomaticDistributionUnassignedOrderAnalysis(requestDate: string): void {
    const result = this.automaticDistribution && this.automaticDistribution.result;
    const transactionId =
      (this.automaticDistribution && this.automaticDistribution.transactionId) ||
      (result && (result.transaction_id || result.transactionId)) ||
      null;
    const transactionDate = this.automaticDistribution && this.automaticDistribution.transactionDate;

    if (!transactionId || (transactionDate && transactionDate !== requestDate)) {
      return;
    }

    this.automaticDistribution.transactionId = String(transactionId);
    this.automaticDistribution.transactionDate = requestDate;

    if (this.automaticDistributionAnalysisSubscription) {
      this.automaticDistributionAnalysisSubscription.unsubscribe();
    }

    this.automaticDistribution.analysisLoading = true;
    this.automaticDistribution.analysisError = null;

    this.automaticDistributionAnalysisSubscription = this.ticketsAssignService
      .getAutomaticDistributionUnassignedOrderAnalysis(transactionId)
      .subscribe(
        (response) => {
          if (
            requestDate !== this.getAutomaticDistributionDate() ||
            String(this.automaticDistribution.transactionId) !== String(transactionId)
          ) {
            this.automaticDistributionAnalysisSubscription = null;
            return;
          }

          const analysisData = this.getAutomaticDistributionUnassignedOrderAnalysisResponse(response);
          const status = analysisData && analysisData.status ? String(analysisData.status).toLowerCase() : '';
          const analyses = analysisData && Array.isArray(analysisData.analyses) ? analysisData.analyses : [];

          if (this.isAutomaticDistributionAnalysisPending(status)) {
            this.automaticDistributionAnalysisSubscription = null;
            this.automaticDistributionAnalysisPollingTimerId = setTimeout(() => {
              this.automaticDistributionAnalysisPollingTimerId = null;
              this.pollAutomaticDistributionUnassignedOrderAnalysis(requestDate);
            }, this.automaticDistributionPollingIntervalMs);
            return;
          }

          if (this.isAutomaticDistributionAnalysisFailed(status) || analysisData.error) {
            this.automaticDistribution.analysisLoading = false;
            this.automaticDistribution.analysisError =
              analysisData.error || 'Не удалось выполнить AI-анализ нераспределенных заявок.';
            this.automaticDistributionAnalysisSubscription = null;
            return;
          }

          if (this.automaticDistribution.result && analyses.length) {
            this.automaticDistribution.result = this.mergeAutomaticDistributionUnassignedOrderAnalysis(
              this.automaticDistribution.result,
              analyses
            );
          }

          this.automaticDistribution.analysisLoading = false;
          this.automaticDistribution.analysisError = null;
          this.automaticDistributionAnalysisSubscription = null;
        },
        () => {
          if (
            requestDate !== this.getAutomaticDistributionDate() ||
            String(this.automaticDistribution.transactionId) !== String(transactionId)
          ) {
            this.automaticDistributionAnalysisSubscription = null;
            return;
          }

          this.automaticDistribution.analysisLoading = false;
          this.automaticDistribution.analysisError = 'Не удалось загрузить AI-анализ нераспределенных заявок.';
          this.automaticDistributionAnalysisSubscription = null;
        }
      );
  }

  private stopAutomaticDistributionAnalysisPolling(): void {
    if (this.automaticDistributionAnalysisPollingTimerId) {
      clearTimeout(this.automaticDistributionAnalysisPollingTimerId);
      this.automaticDistributionAnalysisPollingTimerId = null;
    }

    if (this.automaticDistributionAnalysisSubscription) {
      this.automaticDistributionAnalysisSubscription.unsubscribe();
      this.automaticDistributionAnalysisSubscription = null;
    }

    this.automaticDistribution.analysisLoading = false;
  }

  private refreshAutomaticDistributionResultForCurrentDate(): void {
    if (!this.isAutomaticDistributionResultVisible()) {
      return;
    }

    const selectedDate = this.getAutomaticDistributionDate();

    if (this.automaticDistribution.resultDate === selectedDate && this.automaticDistribution.result) {
      return;
    }

    this.loadAutomaticDistributionResult(true);
  }

  private makeAutomaticDistributionParams(includeDate: boolean): any {
    const params: any = {
      sector_id: this.parentParams.sectorSelected && this.parentParams.sectorSelected.sector_id,
    };

    if (includeDate) {
      params.date = this.getAutomaticDistributionDate();
    }

    return params;
  }

  private makeAutomaticDistributionResultParams(): any {
    const params = this.makeAutomaticDistributionParams(true);
    const transactionId = this.automaticDistribution && this.automaticDistribution.transactionId;
    const transactionDate = this.automaticDistribution && this.automaticDistribution.transactionDate;

    if (transactionId && transactionDate === params.date) {
      params.transaction_id = String(transactionId);
    }

    return params;
  }

  private getAutomaticDistributionDate(): string {
    const filterStartDate = this.childParams && this.childParams.int_begin;
    const date = filterStartDate && this.moment(filterStartDate).isValid() ? this.moment(filterStartDate) : this.moment();

    return date.format('YYYY-MM-DD');
  }

  private getAutomaticDistributionResponseData(response) {
    return response && response.data !== undefined ? response.data : response;
  }

  private getAutomaticDistributionResultData(response) {
    const data = this.getAutomaticDistributionResponseData(response);
    const result = data && (data.results || data.result);
    const input = data && (data.inputs || data.input);

    if (result && typeof result === 'object') {
      return Object.assign({}, result, {
        input: result.input || result.inputs || input,
        inputs: result.inputs || result.input || input,
        planning_session_id: data.planning_session_id,
        transaction_id: data.transaction_id || data.transactionId,
        status: data.status,
        is_applied: data.is_applied !== undefined ? data.is_applied : result.is_applied,
      });
    }

    if (data && data.inputs && !data.input) {
      return Object.assign({}, data, {
        input: data.inputs,
      });
    }

    return data;
  }

  private loadAutomaticDistributionOriginalTickets(): void {
    const resultDate = this.getAutomaticDistributionDate();
    const sectorId = this.parentParams.sectorSelected && this.parentParams.sectorSelected.sector_id;
    const context = `${sectorId || ''}:${resultDate || ''}`;

    if (
      this.automaticDistribution.originalTicketsContext === context &&
      (this.automaticDistribution.originalTickets !== null || this.automaticDistribution.originalTicketsLoading)
    ) {
      return;
    }

    if (this.automaticDistributionOriginalTicketsSubscription) {
      this.automaticDistributionOriginalTicketsSubscription.unsubscribe();
    }

    this.automaticDistribution.originalTicketsContext = context;
    this.automaticDistribution.originalTickets = null;
    this.automaticDistribution.originalTicketsLoading = true;
    this.automaticDistribution.originalTicketsError = null;

    this.automaticDistributionOriginalTicketsSubscription = this.ticketsAssignService
      .getTickets(this.makeAutomaticDistributionOriginalTicketsParams(resultDate))
      .subscribe(
        (response) => {
          if (this.automaticDistribution.originalTicketsContext !== context) {
            return;
          }

          this.automaticDistribution.originalTickets = cloneDeep((response && response.data) || []);
          this.automaticDistribution.originalTicketsLoading = false;
          this.automaticDistributionOriginalTicketsSubscription = null;
        },
        () => {
          if (this.automaticDistribution.originalTicketsContext !== context) {
            return;
          }

          this.automaticDistribution.originalTickets = [];
          this.automaticDistribution.originalTicketsLoading = false;
          this.automaticDistribution.originalTicketsError = 'Не удалось загрузить исходные заявки за выбранный день.';
          this.automaticDistributionOriginalTicketsSubscription = null;
        }
      );
  }

  private makeAutomaticDistributionOriginalTicketsParams(resultDate: string): any {
    const date = this.moment(resultDate, 'YYYY-MM-DD', true);

    return {
      int_begin: date.clone().startOf('day').format(this.dateFullFormat),
      int_end: date.clone().endOf('day').format(this.dateFullFormat),
      districts_ids: '',
      address: '',
      tickets_types_ids: ['1', '2', '3', '5', '4', '6'],
      brigades_ids: '',
      hd_ticket_number: '',
      ticket_status: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '11', '10'],
      hd_ticket_status_group: ['1', '2', '3', '4', '5', '6', '7', '8'],
      '': ['', '', '', ''],
      sector_id: String(this.parentParams.sectorSelected && this.parentParams.sectorSelected.sector_id),
      groups: String(AuthGroupTypesEnum.ServiceEngineer),
    };
  }

  private isAutomaticDistributionPositiveResult(response): boolean {
    const data = this.getAutomaticDistributionResponseData(response);
    const result = data && data.result;

    return result === true || result === 'true' || result === 1 || result === '1';
  }

  private isAutomaticDistributionNegativeResult(response): boolean {
    const data = this.getAutomaticDistributionResponseData(response);

    return !!(data && data.result !== undefined && !this.isAutomaticDistributionPositiveResult(response));
  }

  private getAutomaticDistributionTransactionId(response): string | null {
    const data = this.getAutomaticDistributionResponseData(response);
    const transactionId = data && (data.transaction_id || data.transactionId);

    return transactionId ? String(transactionId) : null;
  }

  private getAutomaticDistributionUnassignedOrderAnalysisResponse(response) {
    return this.getAutomaticDistributionResponseData(response);
  }

  private isAutomaticDistributionAnalysisPending(status: string): boolean {
    return !!status && this.automaticDistributionAnalysisPendingStatuses.indexOf(status) !== -1;
  }

  private isAutomaticDistributionAnalysisFailed(status: string): boolean {
    return !!status && this.automaticDistributionAnalysisFailedStatuses.indexOf(status) !== -1;
  }

  private mergeAutomaticDistributionUnassignedOrderAnalysis(result, analysis: any[]) {
    if (!result || !analysis) {
      return result;
    }

    return Object.assign({}, result, {
      diagnostics: Object.assign({}, result.diagnostics || {}, {
        ai_unassigned_analysis: analysis,
      }),
    });
  }

  private checkAssignedTickets(): boolean {
    return this.brigadeAssignData.brigades && this.brigadeAssignData.brigades.length > 0;
  }

  public changeDayForAssigment(day): void {
    const ticketsCurrentFilter = cloneDeep(this.ticketsCurrentFilter);
    const currentDate = +new Date();
    const workingDateAssign = this.moment(this.ticketsCurrentFilter.ticketsSettings.tomorrow_assignment_time).valueOf();

    if (currentDate < workingDateAssign && day.id === 2) {
      ticketsCurrentFilter.assignDaySelected = this.ticketsCurrentFilter.assignDaysList[0];
      this.ticketsCurrentFilter = ticketsCurrentFilter;

      const alertDialog = this.modalService.open(ConfirmModalComponent, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'modal-wrapper',
        backdrop: 'static',
      });

      alertDialog.componentInstance.title = 'Ошибка';
      alertDialog.componentInstance.description = `Назначение заявок на завтрашние бригады будет доступно<br> с
             ${this.moment(this.ticketsCurrentFilter.ticketsSettings.tomorrow_assignment_time).format('HH:mm')}`;
      alertDialog.componentInstance.abortButtonName = 'Закрыть';
    } else {
      ticketsCurrentFilter.assignDaySelected = day;
      this.ticketsCurrentFilter = ticketsCurrentFilter;
      this.getBrigadesForDayAssigment(this.makeDayAssigmentParams()).then(() => {
        this.onResetCheckedTickets();
        this.resetTicketStatus();
        this.recalculate();
        this.changeBrigadesName();
      });
    }
  }

  public recalculate() {
    if (this.authService.isGRSUser()) {
      this.ticketsCurrentFilter.recalculateStatusAndTickets();
    } else {
      this.recalculateStatusAndTickets();
    }
  }

  public onChangeBrigadeForAssigment(brigade): void {
    this.ticketsMultipleAssign.brigadeSelected = brigade;
  }

  public onChangeCheckedTicket(): void {
    const checkedTickets = this.tickets.dataFlatList.filter((t) => t.isChecked);

    this.ticketsMultipleAssign.ticketsChecked = checkedTickets;
    this.ticketsMultipleAssign.isExistCheckedTicket = checkedTickets.length > 0;
  }

  public onAddTicketsToBrigades(): void {
    const dateFullFormat = Enums.dates.fullFormat;
    const currentFilter = this.ticketsCurrentFilter;
    const ticketsMultipleAssign = this.ticketsMultipleAssign;
    const assignBrigade = ticketsMultipleAssign.brigadeSelected;
    const scheduleDate = this.moment(currentFilter.ticketsSettings.tomorrow_assignment_time)
      .add(currentFilter.assignDaySelected.countDays, 'day')
      .startOf('day')
      .format(dateFullFormat);

    each(this.ticketsMultipleAssign.ticketsChecked, (ticket) => {
      this.brigadeAssignData.addBrigade({
        ticket_id: ticket.id,
        ticket_number: ticket.hd_ticket_number,
        ticket_type: ticket.ticket_type,
        brigade_id: assignBrigade.id,
        schedule_date: scheduleDate,
        sector_id: this.parentParams.sectorSelected.sector_id,
      });

      ticket.brigade = {
        id: assignBrigade.id,
        brigade_name: assignBrigade.brigade_name,
      };
      ticket.isChecked = false;
    });

    ticketsMultipleAssign.brigadeSelected = null;
    ticketsMultipleAssign.ticketsChecked = null;
    ticketsMultipleAssign.isExistCheckedTicket = false;

    this.ticketsMultipleAssign = Object.assign({}, ticketsMultipleAssign);
  }

  private updateCountBrigade(ticketIndex, obj): void {
    const ticketsMultipleAssign = this.ticketsMultipleAssign;
    const ticket = this.tickets.dataFlatList[ticketIndex];
    const oldBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (b: any) => b.id === ticket.brigade.id || b.id === ticket.brigade.brigade_id);
    const newBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (b: any) => b.id === obj.brigade_id);

    if (oldBrigadeIndex > -1) {
      ticketsMultipleAssign.brigades[oldBrigadeIndex].tickets_count -= 1;
    }

    if (newBrigadeIndex > -1) {
      ticketsMultipleAssign.brigades[newBrigadeIndex].tickets_count += 1;
    }
  }

  public addAssignBrigade(obj): void {
    const ticketsMultipleAssign = this.ticketsMultipleAssign;
    let ticketIndex = findIndex(this.tickets.dataFlatList, (t: any) => t.id === obj.ticket_id);
    let index = findIndex(this.brigadeAssignData.brigades, (brigade) => brigade.ticket_id === obj.ticket_id);
    let ticket = this.tickets.dataFlatList[ticketIndex];

    this.brigadeAssignData.isAssignedSuccess = false;

    if (index > -1) {
      if (ticket && ticket.brigade_default && ticket.brigade_default.id === obj.brigade_id) {
        obj.brigade_old_id = (ticket.brigade && ticket.brigade.id) || (ticket.brigade_default && ticket.brigade_default.id);
        this.removeAssignBrigade(obj);
      } else {
        this.brigadeAssignData.brigades[index].brigade_id = obj.brigade_id;
        this.updateCountBrigade(ticketIndex, obj);
      }
    } else {
      if (ticket) {
        ticket = this.tickets.dataFlatList[ticketIndex];

        if (!ticket.brigade) {
          this.ticketsCurrentFilter.currentFilterTypes.assigned.counts += 1;
          this.ticketsCurrentFilter.currentFilterTypes.unassigned.counts -= 1;

          const newBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (b: any) => b.id === obj.brigade_id);

          if (newBrigadeIndex > -1) {
            ticketsMultipleAssign.brigades[newBrigadeIndex].tickets_count += 1;
          }
        } else {
          this.updateCountBrigade(ticketIndex, obj);
        }
      }

      this.brigadeAssignData.brigades.push(obj);
    }

    this.changeBrigadesName();
  }

  public removeAssignBrigade(obj: any): void {
    const ticketsMultipleAssign = this.ticketsMultipleAssign;
    const oldBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (b: any) => b.id === obj.brigade_old_id);
    let index = findIndex(this.brigadeAssignData.brigades, (brigade) => brigade.ticket_id === obj.ticket_id);
    let ticketIndex = findIndex(this.tickets.dataFlatList, (t: any) => t.id === obj.ticket_id);
    let ticket = this.tickets.dataFlatList[ticketIndex];

    this.brigadeAssignData.isAssignedSuccess = false;

    if (index > -1) {
      if (ticket && !ticket.brigade_default) {
        this.brigadeAssignData.brigades.splice(index, 1);
        ticketsMultipleAssign.brigades[oldBrigadeIndex].tickets_count -= 1;
        this.ticketsCurrentFilter.currentFilterTypes.assigned.counts -= 1;
        this.ticketsCurrentFilter.currentFilterTypes.unassigned.counts += 1;
        this.changeBrigadesName();
      } else if (ticket && ticket.brigade_default && ticket.brigade_default.id === obj.brigade_id) {
        const newBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (b: any) => b.id === obj.brigade_id);

        if (newBrigadeIndex > -1) {
          ticketsMultipleAssign.brigades[newBrigadeIndex].tickets_count += 1;
        }

        if (obj.brigade_id !== obj.brigade_old_id && obj.brigade_old_id) {
          ticketsMultipleAssign.brigades[oldBrigadeIndex].tickets_count -= 1;
        }

        this.brigadeAssignData.brigades.splice(index, 1);
        this.ticketsCurrentFilter.currentFilterTypes.assigned.counts -= 1;
        this.ticketsCurrentFilter.currentFilterTypes.unassigned.counts += 1;
        this.changeBrigadesName();
      } else {
        this.brigadeAssignData.brigades[index].brigade_id = null;
      }
    } else {
      ticketsMultipleAssign.brigades[oldBrigadeIndex].tickets_count -= 1;
      this.ticketsCurrentFilter.currentFilterTypes.assigned.counts -= 1;
      this.ticketsCurrentFilter.currentFilterTypes.unassigned.counts += 1;

      this.brigadeAssignData.brigades.push(obj);
      this.changeBrigadesName();
    }
  }

  public assignBrigades(): void {
    const brigadesAssign = cloneDeep(this.brigadeAssignData.brigades).map((brigade) => {
      delete brigade.ticket_number;
      return brigade;
    });
    this.brigadeAssignData.isAssignedLoading = true;

    let assignOrCreate$;

    if (this.authService.isGRSUser()) {
      const grsTickets = brigadesAssign.filter((assign) => assign.ticket_type.id === TicketTypesEnum.GlobalProblemGRS);

      if (!grsTickets.length) {
        return;
      }

      const groupsByBrigadeId = groupBy(grsTickets, 'brigade_id');

      assignOrCreate$ = forkJoin(
        map(groupsByBrigadeId, (tickets, brigadeId) => {
          return this.ticketsAssignService.createDeparture(
            brigadeId,
            tickets.map((t) => t.ticket_id)
          );
        })
      );
    } else {
      assignOrCreate$ = this.ticketsAssignService.assignBrigades(brigadesAssign);
    }

    assignOrCreate$.subscribe(
      () => {
        this.brigadeAssignData.isAssignedSuccess = true;
        this.brigadeAssignData.brigades = [];
        this.getBrigadesAndTickets();
        this.brigadeAssignData.isAssignedLoading = false;
      },
      (error) => {
        if (error.status === 400) {
          const errorsList = [];
          const errors = error.error.data || error.error.error;

          each(errors, (err, index) => {
            if (!isEmpty(err)) {
              const errObj = {
                ticket_number: this.brigadeAssignData.brigades[index].ticket_number,
                errors: [],
              };

              each(err, (value) => {
                if (value && isArray(value)) {
                  errObj.errors = errObj.errors.concat(value);
                }
              });

              errorsList.push(errObj);
            }
          });

          if (errorsList.length) {
            this.openBrigadeAssignErrorModal(errorsList);
          }
        }
        this.brigadeAssignData.isAssignedLoading = false;
      }
    );
  }

  private openBrigadeAssignErrorModal(errors) {
    const brigadeAssignErrorModal = this.modalService.open(TicketsAssignErrorModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper modal-wrapper--w-600',
      backdrop: 'static',
    });

    brigadeAssignErrorModal.componentInstance.errorsList = errors;
  }

  public onAssignedConfirmDialog(): NgbModalRef {
    const assignedConfirmDialog = this.modalService.open(ConfirmModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });

    assignedConfirmDialog.componentInstance.title = 'Подтвердите обновление без сохранения';
    assignedConfirmDialog.componentInstance.description =
      'На странице есть не отправленные в работу заявки с ' +
      'назначенной бригадой. После обновления списка заявок изменения не сохранятся. Вы действительно хотите' +
      ' обновить список заявок? ';
    assignedConfirmDialog.componentInstance.successButtonName = 'Да, обновить';
    assignedConfirmDialog.componentInstance.abortButtonName = 'Отмена';

    return assignedConfirmDialog;
  }

  public changeTypeSelected(type): void {
    const currentFilter = this.ticketsCurrentFilter;

    currentFilter.currentFilterTypeSelected = currentFilter.currentFilterTypes[type];
    this.filteringTicketsByStatus();

    // Принудительно обновляем представление для матричного режима
    this.cdr.detectChanges();

    // Запускаем обновление в зоне Angular для гарантированной перерисовки
    this.ngZone.run(() => {
      setTimeout(() => {
        this.cdr.detectChanges();
      }, 0);
    });
  }

  public onResetCheckedTickets(): void {
    const ticketsMultipleAssign = this.ticketsMultipleAssign;

    // Сбрасываем чекбоксы в основном списке
    each(this.tickets.dataFlatList, (ticket) => {
      ticket.isChecked = false;
    });

    // Также сбрасываем чекбоксы в матричном режиме
    if (this.tickets.dataMatrix) {
      each(this.tickets.dataMatrix, (dateData) => {
        if (dateData.intervals && dateData.intervals.intervals) {
          each(dateData.intervals.intervals, (interval) => {
            if (interval.tickets) {
              each(interval.tickets, (ticket) => {
                ticket.isChecked = false;
              });
            }
          });
        }
      });
    }

    ticketsMultipleAssign.ticketsChecked = null;
    ticketsMultipleAssign.isExistCheckedTicket = false;
  }

  public ticketsListRefresh(): void {
    const filter = this.ticketsCurrentFilter;

    if (this.checkAssignedTickets()) {
      this.onAssignedConfirmDialog().result.then(
        () => {
          filter.currentFilterTypeSelected = filter.currentFilterTypes.all;
          this.brigadeAssignData.brigades = [];
          this.brigadeAssignData.isAssignedSuccess = false;
          this.getBrigadesAndTickets();
        },
        () => {}
      );
    } else {
      filter.currentFilterTypeSelected = filter.currentFilterTypes.all;
      this.brigadeAssignData.brigades = [];
      this.brigadeAssignData.isAssignedSuccess = false;
      this.getBrigadesAndTickets();
    }
  }

  public onChangeMode(mode): void {
    this.ticketsCurrentFilter.mode = mode;
  }

  private isTicketAssigned(ticket): boolean {
    // 1. Проверяем, было ли сделано назначение в текущей сессии
    const assignmentInSession = find(this.brigadeAssignData.brigades, { ticket_id: ticket.id });
    if (assignmentInSession) {
      // Если есть запись в `brigadeAssignData`, это решение имеет приоритет
      // !!assignmentInSession.brigade_id вернет false если бригада была снята (id = null)
      return !!assignmentInSession.brigade_id;
    }
    // 2. Если в сессии решения не было, смотрим на исходные данные заявки с сервера
    return !!(ticket && ticket.brigade && (ticket.brigade.id || ticket.brigade.brigade_id));
  }
}
